import React, { useEffect, useState } from 'react';
import { Button } from '@trevor/ui-components';
import { userAction } from '@/util/helpers/ajax-helpers';
import { useSearchContext } from '../../../../context';
import { highlightSearch } from '../../utils';
import { toColumnInfo } from '../ColumnInfo';
import { negate } from '../../../../util/fp';
import { GroupedColumnEntitiesBySearch, TableEntity } from '../../types';
import styles from './TableInfo.module.scss';

export const USER_ACTION = 'sql-schema-nav';

export type TableInfoProps = {
  table: TableEntity;
  onAddTable?: F<TableEntity, void>;
  onMap: boolean;
  columns: GroupedColumnEntitiesBySearch;
};

export const TableInfo: React.FC<TableInfoProps> = ({
  table,
  onAddTable,
  onMap,
  columns,
}) => {
  const [search, searchTerms] = useSearchContext();
  const [expanded, setExpanded] = useState(false);
  const [mismatchingFolded, setMismatchingFolded] = useState(true);

  const toggle = () => {
    setExpanded(negate);
    userAction(USER_ACTION);
  };

  const expandNotMatchingColumns = () => {
    setMismatchingFolded(false);
    userAction(USER_ACTION);
  };

  const { matching, mismatching } = columns;

  useEffect(() => {
    setExpanded(search.length > 1);
  }, [search]);

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div onClick={toggle} className={styles.nameContainer}>
          <i className={expanded ? styles.arrowDown : styles.arrowRight} />
          <div className={styles.name}>
            {highlightSearch(table.table(), searchTerms)}
          </div>
        </div>
        {!onMap && onAddTable && (
          <Button
            variant="secondary"
            size="small"
            onClick={() => onAddTable(table)}
          >
            Add to map
          </Button>
        )}
      </div>
      {expanded && (
        <div className={styles.columnsInfoContainer}>
          {matching.map(toColumnInfo)}
          {mismatching.length !== 0 && mismatchingFolded ? (
            <div className={styles.foldedColumnsContainer}>
              <div className={styles.foldedColumnsInfo}>
                {mismatching.length} columns hidden&nbsp;
                <button
                  onClick={expandNotMatchingColumns}
                  className={styles.expandButton}
                >
                  show
                </button>
              </div>
            </div>
          ) : (
            mismatching.map(toColumnInfo)
          )}
        </div>
      )}
    </div>
  );
};
